import { useState, useEffect, useCallback } from 'react'
import { withUserContext } from 'context';

import { useRouter } from 'next/router'

//* Components
import { Image, Text, LikesCount } from 'components/common'
import { Tooltip } from 'antd';

const LikeSystem = ({ ...props }) => {
    const router = useRouter()

    const [toggleReactionPopup, setToggleReactionPopup] = useState(false)
    const [likeType, setLikeType] = useState(props.checkLike(props.feedbackId))

    const [likes, setLikes] = useState({
        stronglyDisagreeCount: props.stronglyDisagreeCount,
        disagreeCount: props.disagreeCount,
        neutrealCount: props.neutrealCount,
        agreeCount: props.agreeCount,
        stronglyAgreeCount: props.stronglyAgreeCount,
        likesCount: props.likesCount,
    })

    useEffect(() => {
        if (toggleReactionPopup) {
            document.addEventListener('click', clickHandler)

            return () => {
                document.removeEventListener('click', clickHandler)
            }
        }
    }, [toggleReactionPopup])

    useEffect(() => {
        setToggleReactionPopup(false)
    }, [router])

    const clickHandler = useCallback(() => {
        setToggleReactionPopup(false)
    }, [])

    const toggleFeedbackLike = (type) => {
        if (!props.isFinished) {
            if (props.isLoggedIn) {
                props.toggleFeedbackLike({
                    feedback_id: props.feedbackId,
                    type: type
                }).then(({ newType, newLikesCount }) => {
                    setLikeType(newType)
                    setLikes(newLikesCount)
                })
            } else {
                router.push(`${router.asPath}?c=login`)
            }
        }
    }

    return (
        <div className='review-cont'>
            <div className={`review-popup flexBox ${toggleReactionPopup ? 'active' : ''}`}>
                <Tooltip onClick={() => { toggleFeedbackLike('stronglyDisagree'); setToggleReactionPopup(false) }} placement="top" title="strongly disagree">
                    <Image src='/images/reviewSvgs/stronglyDisagree.svg' />
                    <Text tag={'p'} className='h8 PopReg' text={likes.stronglyDisagreeCount} />
                </Tooltip>
                <Tooltip onClick={() => { toggleFeedbackLike('disagree'); setToggleReactionPopup(false) }} placement="top" title="disagree">
                    <Image src='/images/reviewSvgs/disagree.svg' />
                    <Text tag={'p'} className='h8 PopReg' text={likes.disagreeCount} />
                </Tooltip>
                <Tooltip onClick={() => { toggleFeedbackLike('neutreal'); setToggleReactionPopup(false) }} placement="top" title="neutreal">
                    <Image src='/images/reviewSvgs/neutreal.svg' />
                    <Text tag={'p'} className='h8 PopReg' text={likes.neutrealCount} />
                </Tooltip>
                <Tooltip onClick={() => { toggleFeedbackLike('agree'); setToggleReactionPopup(false) }} placement="top" title="agree">
                    <Image src='/images/reviewSvgs/agree.svg' />
                    <Text tag={'p'} className='h8 PopReg' text={likes.agreeCount} />
                </Tooltip>
                <Tooltip onClick={() => { toggleFeedbackLike('stronglyAgree'); setToggleReactionPopup(false) }} placement="top" title="strongly agree">
                    <Image src='/images/reviewSvgs/stronglyAgree.svg' />
                    <Text tag={'p'} className='h8 PopReg' text={likes.stronglyAgreeCount} />
                </Tooltip>
            </div>
            <LikesCount
                id={props.feedbackId}
                onClick={() => setToggleReactionPopup(!toggleReactionPopup)}
                className='op-like'
                likesCount={likes.likesCount}
                likeType={likeType}
            />
        </div>
    )
}

export default withUserContext(LikeSystem, ['toggleFeedbackLike', 'checkLike', 'isLoggedIn']);